module.exports = __webpack_public_path__ + "static/media/Encomienda_Express_480x480px.e6ea0d33.jpg";